import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import {
  HomeIcon,
  BookOpenIcon,
  UserIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';

interface FooterProps {
  className?: string;
}

export const Footer: React.FC<FooterProps> = ({ className = '' }) => {
  const location = useLocation();

  const navigation = [
    { name: 'Home', href: '/', icon: HomeIcon },
    { name: 'Materie', href: '/subjects', icon: BookOpenIcon },
    { name: 'Profilo', href: '/profile', icon: UserIcon },
    { name: 'Credit', href: '/credits', icon: InformationCircleIcon },
  ];

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <footer className={`bg-white border-t border-gray-200 flex-shrink-0 ${className}`}>
      {/* Navigation Footer - Solo su mobile */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-[60] shadow-lg">
        <nav className="flex justify-around items-center py-3 px-4">
          {navigation.map((item) => {
            const Icon = item.icon;
            return (
              <Link
                key={item.name}
                to={item.href}
                className={`flex flex-col items-center space-y-1 px-3 py-2 rounded-lg text-xs font-medium transition-colors duration-200 ${
                  isActive(item.href)
                    ? 'text-primary-600'
                    : 'text-gray-500 hover:text-gray-700'
                }`}
              >
                <Icon className={`h-6 w-6 ${isActive(item.href) ? 'text-primary-600' : 'text-gray-500'}`} />
                <span className="text-xs">{item.name}</span>
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Copyright Footer - Solo su desktop */}
      <div className="hidden md:block py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            {/* Prima riga */}
            <p className="text-sm text-gray-600">
              Live Concorsi. © 2025 D-Serviceitalia srl Tutti i diritti riservati.
            </p>
            
            {/* Seconda riga */}
            <p className="text-sm text-gray-500 mt-1">
              Preparati ai concorsi con quiz interattivi e simulazioni realistiche.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
